import Button from '@mui/material/Button';
import { Download } from 'react-feather';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { SBOMContext } from '../../../pages/NRSBOMTable/NRSBOMDataShare';
import SBOMButtonStyles from './SBOMButton.styles';

const useStyles = makeStyles(SBOMButtonStyles);
function SBOMButton() {
  const classes = useStyles();
  const { openAddDependencyModal, setOpenAddDependencyModal } = useContext(SBOMContext);
  const handleClick = event => {
    setOpenAddDependencyModal(true);
  };
  return (
    <Box className={classes.addComponentButton}>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        variant="outlined"
        color="secondary"
        classes={{ root: classes.downloadButton }}
        aria-expanded={openAddDependencyModal ? 'true' : undefined}
        onClick={handleClick}
      >
        <Typography variant="subtitle2" component="span">
          Add Component
        </Typography>
      </Button>
    </Box>
  );
}

export default SBOMButton;
